<template>
  <div v-if="!loading">
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.nif')">
      <b-form-input
        v-model="item.nif"
        name="nif"
        type="number"
        required
        placeholder="123456789"
      />
    </b-form-group>
    <b-form-group :label="$t('field.address')">
      <b-form-input
        v-model="item.address"
        name="address"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.country')">
      <b-form-input
        v-model="item.country"
        name="county"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.zip_code')">
          <b-form-input
            v-model="item.zip_code"
            name="zip_code"
            type="text"
            required
            placeholder="1234-123"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.locality')">
          <b-form-input
            v-model="item.locality"
            name="locality"
            type="text"
            required
            placeholder="Lorem ipsum set dolor"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.website')">
      <b-form-input
        v-model="item.website"
        name="website"
        type="text"
        required
        placeholder="www.website.com"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.share_capital')">
          <b-input-group append="€">
            <b-form-input
              v-model="item.share_capital"
              name="share_capital"
              type="text"
              required
              placeholder="2000000.00"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.register')">
          <b-form-input
            v-model="item.register"
            name="register"
            type="text"
            required
            placeholder="Cascais"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.logo')">
      <div class="d-flex align-items-center">
        <image-uploader
          :max-width="1920"
          className="d-none"
          :quality="1"
          :auto-rotate="true"
          :preview="false"
          outputFormat="verbose"
          accept="image/*"
          do-not-resize="['gif', 'svg']"
          @input="imageUploaded"
        >
          <label
            for="fileInput"
            slot="upload-label"
            class="d-inline-flex align-items-center justify-content-between mb-0"
          >
            <div
              class="choose-logo-btn rounded px-5 py-2 fs-14 shadow-sm border border-primary text-primary align-items-center justify-content-center"
            >
              <span>{{ $t("actions.pick_logo") }}</span>
            </div>
          </label>
        </image-uploader>
      </div>
      <div class="w-75 mt-4">
        <img :src="logo" class="w-auto mw-100" />
      </div>
    </b-form-group>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import model from '@/models/companies'
import edit from '@/mixins/edit'
import { mapGetters } from 'vuex'

export default {
  mixins: [edit],
  data: () => ({
    model: JSON.parse(JSON.stringify(model.empty)),
    logo: null,
    loading: true
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields'
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.setLogo()
      this.loading = false
    },
    setLogo() {
      if (this.item.file) {
        this.logo = this.item.file
      }
    },
    imageUploaded(file) {
      this.setImage(file.dataUrl)
      this.logo = file.dataUrl
      this.item.file = this.model.file
    }
  }
}
</script>
<style lang="scss" scoped>
.choose-logo-btn {
  cursor: pointer;
}
</style>